import { render, staticRenderFns } from "./requestLogDetail.vue?vue&type=template&id=2bbc9aa1&scoped=true"
import script from "./requestLogDetail.vue?vue&type=script&lang=js"
export * from "./requestLogDetail.vue?vue&type=script&lang=js"
import style0 from "./requestLogDetail.vue?vue&type=style&index=0&id=2bbc9aa1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc9aa1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\crmeb\\gitcode\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbc9aa1')) {
      api.createRecord('2bbc9aa1', component.options)
    } else {
      api.reload('2bbc9aa1', component.options)
    }
    module.hot.accept("./requestLogDetail.vue?vue&type=template&id=2bbc9aa1&scoped=true", function () {
      api.rerender('2bbc9aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/requestLogDetail.vue"
export default component.exports